// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"79":"f3b8ade6","86":"08a7e9fc","154":"32984118","274":"4c5facb6","671":"e8a656bb"}[chunkId] + ".css";
};